import { render, staticRenderFns } from "./NewMessageDetail.vue?vue&type=template&id=51b93a42&"
import script from "./NewMessageDetail.vue?vue&type=script&lang=js&"
export * from "./NewMessageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports